import React from 'react';
import TourDateItem from './tour-date-item';

// order=desc for past dates, order=asc for upcoming dates (default)
const TourDateList = ({ tourDates, order = 'asc', isPast = false }) => {
  
  const sorted = [...(tourDates ?? [])].sort((a, b) => {
    const diff = new Date(a.datetime) - new Date(b.datetime);
    return order === 'desc' ? -diff : diff;
  });

  const tourDateItems = sorted.map((tourDate) => {
    return <TourDateItem
      tourDate={tourDate}
      isPast={isPast}
      key={tourDate.id} />
  });

  return (
    <div className="bitw-container">
      <table className="bitw-custom-table">
        <tbody>
          {tourDateItems}
        </tbody>
      </table>
    </div>
  );
}

export default TourDateList
